module.exports = __webpack_public_path__ + "static/graphic-healthcare-66364659c14c214aea4cbf036a5224dd.png";